module.exports = {"500112002":"双龙湖街道","500112004":"回兴街道","500112007":"鸳鸯街道","500112008":"翠云街道","500112009":"人和街道","500112010":"天宫殿街道","500112011":"龙溪街道","500112012":"龙山街道","500112013":"龙塔街道","500112014":"大竹林街道","500112015":"悦来街道","500112016":"两路街道","500112017":"双凤桥街道","500112018":"王家街道","500112019":"礼嘉街道","500112020":"宝圣湖街道","500112021":"金山街道","500112022":"康美街道","500112023":"仙桃街道","500112129":"玉峰山镇","500112131":"龙兴镇","500112133":"统景镇","500112135":"大湾镇","500112138":"兴隆镇","500112139":"木耳镇","500112140":"茨竹镇","500112141":"古路镇","500112142":"石船镇","500112143":"大盛镇","500112144":"洛碛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500112.json
// module id = 2223
// module chunks = 0